import { CALL_API } from "../api.middleware";
import {
  SHOW_PURCHASE_CONFIRMATION,
  SHOW_PURCHASE_CONFIRMATION_SUCCESS,
  SHOW_PURCHASE_CONFIRMATION_FAILED,
  CONFIRM_PURCHASE,
  CONFIRM_PURCHASE_SUCCESS,
  CONFIRM_PURCHASE_FAILED,
  SET_SIP_DETAILS,
  SIP_SAVE_DATA,
  SIP_SAVE_DATA_SUCCESS,
  SIP_SAVE_DATA_FAILED,
  SET_SWITCH_DETAILS,
  SET_STP_DETAILS,
  GET_EARNINGS,
  GET_EARNINGS_SUCCESS,
  GET_EARNINGS_FAILED,
  CLEAR_TRANSACTION_HISTORY,
  RE_INITIATE_TRANSACTION,
  RE_INITIATE_SUCCESS,
  RE_INITIATE_FAILED,
  GET_DASHBOARD_SIP,
  GET_DASHBOARD_SIP_SUCCESS,
  GET_DASHBOARD_SIP_FAILED,
  GET_DASHBOARD_FMP,
  GET_DASHBOARD_FMP_SUCCESS,
  GET_DASHBOARD_FMP_FAILED,
} from "../types";

export const submitPurchaseData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SentpurchasemailRed",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const showPurchaseConfirmation = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ShowpurchaseconfirmationData",
        params,
        method: "GET",
        types: [
          SHOW_PURCHASE_CONFIRMATION,
          SHOW_PURCHASE_CONFIRMATION_SUCCESS,
          SHOW_PURCHASE_CONFIRMATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const saveSipData = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SIPSave",
        params,
        method: "GET",
        types: [SIP_SAVE_DATA, SIP_SAVE_DATA_SUCCESS, SIP_SAVE_DATA_FAILED],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const confirmPurchase = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveDTRWeb",
        params,
        method: "GET",
        types: [
          CONFIRM_PURCHASE,
          CONFIRM_PURCHASE_SUCCESS,
          CONFIRM_PURCHASE_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getAssetClasses = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetAssetclass",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getOtherSchemes = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getOtherSchemesSwitch",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getBankDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetRedemptionBankDeatils",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getRedemptionPaymentDetails = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/exitloadcalc",
        params,
        method: "GET",
        types: [
          SHOW_PURCHASE_CONFIRMATION,
          SHOW_PURCHASE_CONFIRMATION_SUCCESS,
          SHOW_PURCHASE_CONFIRMATION_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const redemptionConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Savetransaction_red",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const swpOptions = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/getMasterSIP",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const CalcSIPEnddt = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CalcSIPEnddt",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const swpConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SWPDetailsSave_WEB",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const stpConfirm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/SaveSTPconfirmationWeb",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const physicalTransaction = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "",
        body,
        method: "POST",
        isFile: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const setSipDetails = (data) => {
  return {
    type: SET_SIP_DETAILS,
    body: data,
  };
};

export const setSwitchDetails = (data) => {
  return {
    type: SET_SWITCH_DETAILS,
    body: data,
  };
};

export const setStpDetails = (data) => {
  return {
    type: SET_STP_DETAILS,
    body: data,
  };
};

export const clearTransactionHistory = () => {
  return {
    type: CLEAR_TRANSACTION_HISTORY,
  };
};

export const getFundWiseEarnings = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetBrokerageDetails`,
        params,
        method: "GET",
        types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
        showLoader: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getMinimumAmount = (params) => async (dispatch) => {
  return await dispatch({
    [CALL_API]: {
      url: `/Ktrack_GetMinAmt`,
      params,
      method: "GET",
      // types: [GET_EARNINGS, GET_EARNINGS_SUCCESS, GET_EARNINGS_FAILED],
      // showLoader: true
    },
  });
};

export const getNctType = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetNCTKtrackgo`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getNctSave = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: ``,
        body,
        method: "POST",
        isNct: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getEnach = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/enachregdbilldesk`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getFamilyDescription = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/ktrack_Emailmobilefamilyflagdata`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const reInitiateTransaction = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_ReinitiateTransaction",
        params,
        method: "GET",
        types: [
          RE_INITIATE_TRANSACTION,
          RE_INITIATE_SUCCESS,
          RE_INITIATE_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getSIPTransactions = (params) => async (dispatch, getState) => {
  try {
    const { authReducer } = getState() || {};

    const arncode = authReducer && authReducer.token;
    params = { ...params, arncode };

    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_DistDashboard_Sip",
        params,
        method: "GET",
        types: [
          GET_DASHBOARD_SIP,
          GET_DASHBOARD_SIP_SUCCESS,
          GET_DASHBOARD_SIP_FAILED,
        ],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const showPurchaseConfirmationReinitiate =
  (params) => async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/ShowpurchaseconfirmationData_reinitiate",
          params,
          method: "GET",
          types: [
            SHOW_PURCHASE_CONFIRMATION,
            SHOW_PURCHASE_CONFIRMATION_SUCCESS,
            SHOW_PURCHASE_CONFIRMATION_FAILED,
          ],
        },
      });
    } catch (error) {
      alert(`${error}`);
    }
  };

export const checkPanKOTM = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CheckPANKotm",
        params,
        method: "GET",
        types: ["CHECK_PAN_KOTM"],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCheckPanAotm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CheckPANAotm",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const getEnachBankByFolio = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/GetEnachBankByFolio",
        params,
        method: "GET",
        types: ["GET_ENACH"],
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getSipvalues = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/Ktrack_Dist_Dashboard_DIT_SIP_active_inactive",
        params,
        method: "GET",
        types: [
          GET_DASHBOARD_SIP,
          GET_DASHBOARD_SIP_SUCCESS,
          GET_DASHBOARD_SIP_FAILED,
        ],
        showLoader: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getFMPdata = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/ktrack_get_FMPaum",
        params,
        method: "GET",
        types: [
          GET_DASHBOARD_FMP,
          GET_DASHBOARD_FMP_SUCCESS,
          GET_DASHBOARD_FMP_FAILED,
        ],
        showLoader: true,
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getCheckPanKotm = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/CheckPANKotm",
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const getEnachMFS = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/GetEnachFunds`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const isFreedomSIPEligible = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/FreedomSIPEligibleFlag`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    console.error(error)
  }
};
export const FreedomSIPSWPschemes = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/FreedomSIPSWPschemes`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};
export const FreedomSIPTenures = (params) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: `/FreedomSIPTenure`,
        params,
        method: "GET",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};

export const PurchaseSaveNominee = (body) => async (dispatch) => {
  try {
    return await dispatch({
      [CALL_API]: {
        url: "/save-nominee-new-purchase",
        body: Object.keys(body).reduce((acc, curr) => {
          if (body[curr]) acc[curr] = body[curr];
          else acc[curr] = "";
          return acc;
        }, {}),
        method: "POST",
      },
    });
  } catch (error) {
    alert(`${error}`);
  }
};